/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_menu': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M24 18v1H0v-1h24zm0-6v1H0v-1h24zm0-6v1H0V6h24z" _fill="#1040e2"/><path pid="1" d="M24 19H0v-1h24v1zm0-6H0v-1h24v1zm0-6H0V6h24v1z"/>'
  }
})
